import { render, staticRenderFns } from "./AdminPageSecurityGroups.vue?vue&type=template&id=25ff33e3"
import script from "./AdminPageSecurityGroups.vue?vue&type=script&lang=js"
export * from "./AdminPageSecurityGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports